import { render } from "./dashboardData.vue?vue&type=template&id=73d3a337"
import script from "./dashboardData.vue?vue&type=script&lang=js"
export * from "./dashboardData.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/dashboardData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73d3a337"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73d3a337', __exports__)) {
    console.log('reload')
    api.reload('73d3a337', __exports__)
  }
  
  module.hot.accept("./dashboardData.vue?vue&type=template&id=73d3a337", () => {
    console.log('re-render')
    api.rerender('73d3a337', render)
  })

}


export default __exports__